import { AbstractPlugin as E } from "./ghl-ui.es786.js";
import g from "./ghl-ui.es787.js";
const s = Symbol("onDragStart"), i = Symbol("onDragMove"), r = Symbol("onDragStop"), c = Symbol("scroll"), S = {
  speed: 6,
  sensitivity: 50,
  scrollableElements: []
};
class O extends E {
  constructor(t) {
    super(t), this.options = {
      ...S,
      ...this.getOptions()
    }, this.currentMousePosition = null, this.scrollAnimationFrame = null, this.scrollableElement = null, this.findScrollableElementFrame = null, this[s] = this[s].bind(this), this[i] = this[i].bind(this), this[r] = this[r].bind(this), this[c] = this[c].bind(this);
  }
  attach() {
    this.draggable.on("drag:start", this[s]).on("drag:move", this[i]).on("drag:stop", this[r]);
  }
  detach() {
    this.draggable.off("drag:start", this[s]).off("drag:move", this[i]).off("drag:stop", this[r]);
  }
  getOptions() {
    return this.draggable.options.scrollable || {};
  }
  getScrollableElement(t) {
    return this.hasDefinedScrollableElements() ? g(t, this.options.scrollableElements) || document.documentElement : w(t);
  }
  hasDefinedScrollableElements() {
    return this.options.scrollableElements.length !== 0;
  }
  [s](t) {
    this.findScrollableElementFrame = requestAnimationFrame(() => {
      this.scrollableElement = this.getScrollableElement(t.source);
    });
  }
  [i](t) {
    if (this.findScrollableElementFrame = requestAnimationFrame(() => {
      this.scrollableElement = this.getScrollableElement(t.sensorEvent.target);
    }), !this.scrollableElement)
      return;
    const e = t.sensorEvent, o = {
      x: 0,
      y: 0
    };
    "ontouchstart" in window && (o.y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0, o.x = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0), this.currentMousePosition = {
      clientX: e.clientX - o.x,
      clientY: e.clientY - o.y
    }, this.scrollAnimationFrame = requestAnimationFrame(this[c]);
  }
  [r]() {
    cancelAnimationFrame(this.scrollAnimationFrame), cancelAnimationFrame(this.findScrollableElementFrame), this.scrollableElement = null, this.scrollAnimationFrame = null, this.findScrollableElementFrame = null, this.currentMousePosition = null;
  }
  [c]() {
    if (!this.scrollableElement || !this.currentMousePosition)
      return;
    cancelAnimationFrame(this.scrollAnimationFrame);
    const {
      speed: t,
      sensitivity: e
    } = this.options, o = this.scrollableElement.getBoundingClientRect(), a = o.bottom > window.innerHeight, p = o.top < 0 || a, m = b(), n = this.scrollableElement, u = this.currentMousePosition.clientX, f = this.currentMousePosition.clientY;
    if (n !== document.body && n !== document.documentElement && !p) {
      const {
        offsetHeight: h,
        offsetWidth: d
      } = n;
      o.top + h - f < e ? n.scrollTop += t : f - o.top < e && (n.scrollTop -= t), o.left + d - u < e ? n.scrollLeft += t : u - o.left < e && (n.scrollLeft -= t);
    } else {
      const {
        innerHeight: h,
        innerWidth: d
      } = window;
      f < e ? m.scrollTop -= t : h - f < e && (m.scrollTop += t), u < e ? m.scrollLeft -= t : d - u < e && (m.scrollLeft += t);
    }
    this.scrollAnimationFrame = requestAnimationFrame(this[c]);
  }
}
function y(l) {
  const t = /(auto|scroll)/, e = getComputedStyle(l, null), o = e.getPropertyValue("overflow") + e.getPropertyValue("overflow-y") + e.getPropertyValue("overflow-x");
  return t.test(o);
}
function F(l) {
  return getComputedStyle(l).getPropertyValue("position") === "static";
}
function w(l) {
  if (!l)
    return b();
  const t = getComputedStyle(l).getPropertyValue("position"), e = t === "absolute", o = g(l, (a) => e && F(a) ? !1 : y(a));
  return t === "fixed" || !o ? b() : o;
}
function b() {
  return document.scrollingElement || document.documentElement;
}
export {
  O as default,
  S as defaultOptions,
  i as onDragMove,
  s as onDragStart,
  r as onDragStop,
  c as scroll
};
